// extracted by mini-css-extract-plugin
module.exports = {"root":"_0198c7","buttonsContainer":"_e38ec7","placeholderItem":"_c54f1a","placeholderLink":"_4adb97"};